import Router from '@/router/index.js'

const user = JSON.parse(localStorage.getItem('user'))

const state = user ? { user } : { user: null };

const actions = {
    login({ commit }, payload) {
        const user = payload.user;

        localStorage.setItem('token', user.Aa);
        localStorage.setItem('refresh-token', user.refreshToken);
        localStorage.setItem('user', JSON.stringify(user));

        commit('loginSuccess', user);

        location.href = `/oauth?u=${user.uid}`;
    },

    setUserPersonalData({ commit }, payload) {
        commit('changePersonalData', payload)

        location.href = '/dashboard';
    },

    logout({ commit }) {
        commit('logout')
    },

    update({ commit }, payload) {
        localStorage.setItem('user', JSON.stringify(payload.user));

        commit('updateSuccess', payload.user)
    }
}

const mutations = {
    loginSuccess(state, user) {
        state.user = user;
    },

    changeAdminData(state, user) {
        state.user = user
    },

    changePersonalData(state, personalData) {
        state.user.personalData = personalData;

        localStorage.setItem('user', JSON.stringify(state.user));
    },

    loginFailure(state) {
        state.user = null;
    },

    logout(state) {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh-token');
        localStorage.removeItem('user');

        Router.go("/login");

        state.user = null;
    },

    updateSuccess(state, user) {
        state.user = user;
    }
}

const getters = {
    userEmail: state => state.user.email,
    userUuid: state => state.user.uid,
    user: state => state.user,
    displayName: state => state.user.personalData ? `${state.user.personalData.firstName} ${state.user.personalData.lastName}` : state.user.email,
    role: state => state.user.personalData ? state.user.personalData.role : 'utente',
}

export const currentUser = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/currentUser.js